





























































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwToggle } from '@sonicwall/unified-ui-framework/src/shared/sw-toggle';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
const cssPrefix = 'upgrade-popup';

@Component({
  components: {
    ...UUIFComponents,
    SwIcon,
    SwToggle,
    SwButton,
    SwSelect,
  },
})

export default class UpgradePopup extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop() title: String;

  dummy: any = [
    { id: 'op2', label: 'option 2', value: 'op2' },
    { id: 'op3', label: 'option 3', value: 'op3' },
    { id: 'op4', label: 'option 4', value: 'op4' },
    { id: 'op5', label: 'option 5', value: 'op5' },
    { id: 'op6', label: 'option 6', value: 'op6' },
  ];
  dropdownOpen: boolean = false;

  selectedProductOption: any = 'op2';
  get productOptions(): SelectOption[] {
    return this.$store.getters['DownloadCenterStoreModule/getProductOptions'];
  }

  selectedModelOption: any = 'op2';
  get modelOptions(): SelectOption[] {
    return this.$store.getters['DownloadCenterStoreModule/getModelOptions'];
  }

  selectedVersionOption: any = 'op2';
  get versionOptions(): SelectOption[] {
    return this.$store.getters['DownloadCenterStoreModule/getCurrentVersionOptions'];
  }

  upgradeToVersionOption: any = 'op2';
  get upgradeOptions(): SelectOption[] {
    return this.$store.getters['DownloadCenterStoreModule/getUpgradeToVersionOptions'];
  }

  setOptions(data: any, key: any) {
    this.$store.commit('DownloadCenterStoreModule/setUpgradePathPopupOptions', { data, key });
  }

  getDataFromApi() {
    this.setOptions(this.dummy, 'product');
    this.setOptions(this.dummy, 'model');
    this.setOptions(this.dummy, 'currentVersion');
    this.setOptions(this.dummy, 'upgradeToVersion');
  }

  handleClick() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  mounted() {
    this.getDataFromApi();
  }
}
